import { Modal, Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
  title: string;
  content: string;
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  content,
  isVisible,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  
  return (
    <Modal
      title={title}
      open={isVisible}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          {t('cancel', { ns: 'buttons' })}
        </Button>,
        <Button key="submit" type="primary" danger onClick={onConfirm}>
          {t('confirm', { ns: 'buttons' })}
        </Button>,
      ]}
    >
      <p>{content}</p>
    </Modal>
  );
};

export default ConfirmationModal;